export default __webpack_public_path__ + "static/media/s4.16a20804.png";